'use client';
import * as React from 'react';
import type { CellEditableConditionFn } from '../../../models/configuration/gridCellEditableConfiguration';
import { isAutogeneratedRowNode } from '../rows/gridRowsUtils';

/**
 * Default implementation of the cell editable condition hook
 */
export const useIsCellEditable = (): CellEditableConditionFn =>
  React.useCallback((params) => !isAutogeneratedRowNode(params.rowNode), []);
